import { Dropdown } from "primereact/dropdown";
import { useState } from "react";

export function PropertyDropdown({propertyName, initialVal, label, id, options, onDone, itemTemplate, valueTemplate, showClear, filter, filterBy, filterInputAutoFocus, optionValue, optionLabel = 'name'}) {
  const [selectedOption, setSelectedOption] = useState(initialVal);

  return (
      <>
          <label htmlFor={id + '-' + propertyName}>{label}</label>        
          <Dropdown value={selectedOption}
                  inputId={id + '-' + propertyName}  
                  onChange={(e) => {
                      setSelectedOption(e.value);
                      onDone(propertyName,e.value);
                    }
                  } 
                  options={options} 
                  placeholder="(proszę wybrać)" 
                  className="w-full" 
                  itemTemplate={itemTemplate}
                  valueTemplate={valueTemplate}
                  showClear={showClear}
                  filter={filter}
                  filterBy={filterBy}
                  filterInputAutoFocus={filterInputAutoFocus}
                  optionLabel={optionLabel}
                  optionValue={optionValue}
                  style={{maxWidth: '437.25px'}}

          />
      </>

  )
}